import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';

export default function FlightDetails({
  flightDetails,
  flightDirection,
  seperator,
  expanded,
}) {
  const theme = useContext(ThemeContext);
  const now = (date) => {
    return dayjs(date);
  };
  const norwegianLogo =
    'https://static.wowcher.co.uk/images/international-travel/airlines/norwegian.png';

  const airlines = {
    BA:
      'https://static.wowcher.co.uk/images/international-travel/airlines/britishairways.png',
    BE:
      'https://static.wowcher.co.uk/images/international-travel/airlines/flybe.png',
    BY:
      'https://static.wowcher.co.uk/images/international-travel/airlines/tui.png',
    D8: norwegianLogo,
    DI: norwegianLogo,
    DY: norwegianLogo,
    EJ:
      'https://static.wowcher.co.uk/images/international-travel/airlines/easyjet.png',
    EZ:
      'https://static.wowcher.co.uk/images/international-travel/airlines/easyjet.png',
    FR:
      'https://static.wowcher.co.uk/images/international-travel/airlines/ryanair.png',
    LS:
      'https://static.wowcher.co.uk/images/international-travel/airlines/jet2.png',
    MT:
      'https://static.wowcher.co.uk/images/international-travel/airlines/thomascook.png',
    OA:
      'https://static.wowcher.co.uk/images/international-travel/airlines/olympicair.png',
    TO:
      'https://static.wowcher.co.uk/images/international-travel/airlines/tui.png',
    W6:
      'https://static.wowcher.co.uk/images/international-travel/airlines/wizzair.png',
    W9:
      'https://static.wowcher.co.uk/images/international-travel/airlines/wizzair.png',
    WW:
      'https://static.wowcher.co.uk/images/international-travel/airlines/wowair.png',
  };

  const lookupAirlineLogo = (flightNumber) => {
    const twoDigitCode =
      flightNumber && flightNumber.length >= 2 ? flightNumber.slice(0, 2) : '';

    return (
      airlines[twoDigitCode] ||
      'https://static.wowcher.co.uk/images/international-travel/airlines/default.png'
    );
  };

  return (
    <>
      {!expanded ? (
        <table className="bcal-flightData">
          <tbody>
            <tr>
              <td className="flight-cell bcal-flight-logo">
                <img
                  alt="flightDetails.flightNumber"
                  src={lookupAirlineLogo(
                    flightDetails?.flightData?.flightNumber,
                  )}
                />
              </td>
              <td className="flight-cell">
                <div>{flightDirection}</div>
                <div className="strong-text">
                  {now(flightDetails?.flightData?.departureTime).format(
                    'DD/MM/YYYY',
                  )}
                </div>
              </td>
              <td className="flight-cell text-align-right extra-width">
                <div className="flight-time strong-text">
                  {now(flightDetails?.flightData?.departureTime).format(
                    'HH:mm',
                  )}
                </div>
                <div>
                  <strong>{flightDetails?.departure?.code}</strong>
                </div>
              </td>
              <td className="flight-cell">
                <hr />
              </td>
              <td className="flight-cell text-align-left">
                <div className="flight-time strong-text">
                  {now(flightDetails?.flightData?.arrivalTime).format('HH:mm')}
                </div>
                <div>
                  <strong>{flightDetails?.arrival?.code}</strong>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">{seperator && <hr />}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <table className="bcal-flightData expanded">
          <tbody>
            <tr>
              <td className="flight-cell bcal-flight-logo">
                <img
                  alt="flightDetails.flightNumber"
                  src={lookupAirlineLogo(
                    flightDetails?.flightData?.flightNumber,
                  )}
                />
              </td>
              <td className="flight-number">
                <div>Flight Number</div>
                <div className="strong-text">{`${flightDetails?.flightData?.airline} ${flightDetails?.flightData?.flightNumber}`}</div>
              </td>
            </tr>
            <tr>
              <td className="border-right">
                <div>{flightDirection}</div>
                <div className="strong-text">
                  {now(flightDetails?.flightData?.departureTime).format(
                    'DD/MM/YYYY',
                  )}
                </div>
              </td>
              <td className="flight-itinery">
                <div>
                  <span className="flight-time strong-text text-align-left">
                    {now(flightDetails?.flightData?.departureTime).format(
                      'HH:mm',
                    )}
                  </span>{' '}
                  {`${flightDetails?.departure?.code} ${flightDetails?.departure?.name}`}
                </div>

                <div>
                  <span className="flight-time strong-text text-align-left">
                    {now(flightDetails?.flightData?.arrivalTime).format(
                      'HH:mm',
                    )}
                  </span>{' '}
                  {`${flightDetails?.arrival?.code} ${flightDetails?.arrival?.name}`}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      )}
      <style jsx>{`
        .bcal-flightData {
          width: 100%;
        }
        .bcal-flightData .flight-cell,
        .bcal-flightData.expanded {
          padding: 8px 5px;
          text-align: center;
          font-size: 12px;
          line-height: 1.4rem;
          color: ${theme.commoncolors.greyshade};
        }

        .bcal-flightData.expanded {
          background-color: #eeeeee;
          border-collapse: separate;
          margin: 10px 0;
          width: 100%;
        }

        .bcal-flightData.expanded td {
          padding: 8px 5px;
        }

        .bcal-flightData .flight-cell {
          width: 60px;
        }

        .bcal-flightData .flight-cell.extra-width {
          width: 127px;
        }

        .bcal-flightData .flight-cell.text-align-right {
          text-align: right;
          line-height: 1.6rem;
        }

        .bcal-flightData .flight-cell.text-align-left {
          text-align: left;
          line-height: 1.6rem;
        }

        .bcal-flight-logo img {
          width: 45px;
        }

        .strong-text {
          color: ${theme.commoncolors.greycharcoal};
          font-weight: bold;
        }

        .flight-time {
          font-size: 16px;
        }

        .bcal-flightData.expanded .border-right {
          border-right: 1px solid ${theme.commoncolors.greycharcoal};
          padding-right: 15px;
        }

        .bcal-flightData.expanded .flight-number {
          padding-left: 15px;
          text-align: left;
        }

        .bcal-flightData.expanded .flight-itinery {
          text-align: left;
          padding-left: 15px;
          line-height: 2rem;
        }
      `}</style>
    </>
  );
}

FlightDetails.propTypes = {
  expanded: PropTypes.bool,
  flightDetails: PropTypes.object,
  flightDirection: PropTypes.string,
  seperator: PropTypes.bool,
};
